import React from "react";
import HistorischeAuswertung from "../HistorischeAuswertung";

const HistorischWidget = () => (
  <div className="widget-content-scroll">
    <HistorischeAuswertung />
  </div>
);

export default HistorischWidget;
